export default __webpack_public_path__ + "static/media/Path 107.ace7ce1c.svg";